/*
 * @Author: jiangxd
 * @Date: 2022-09-21 09:48:43
 * @LastEditTime: 2022-09-21 15:23:52
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/newSelectSIte/index.tsx
 */

import { client } from 'rsui-core/lib/post-message';
import { JsonToUrlParam } from '@/util';
import { EmpServiceAPIActions } from '@/services/empService';

import { IPSService } from '@/services/ipsServices';




export default class NewSelectSite {

	siteId = '';
	sgId: number;
	selectList: string[];
	readonly: boolean;
	exArr: string[]
	multiple = true

	isOutAuth = 0;
	showAllSite = 0

	siteCodeList: string[] = [];
	allSiteCodes = []

	public tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};


	setParams(params) {
		this.siteId = localStorage.getItem('firstSiteId');
		this.sgId = params.sgId;
		this.selectList = params.selectCodes;
		this.readonly = params.readonly;
		this.exArr = params.exArr;
		this.isOutAuth = params.isOutAuth;
		this.showAllSite = params.showAllSite;

		if (params.hasOwnProperty('multiple')) {
			this.multiple = params.multiple;
		}

		if (params.service) {
			this.sgId = null
		}
	}
	open(params) {
		this.setParams(params);
		return IPSService.adminSiteAuthList({ postParams: { sgId: this.sgId, isOutAuth: this.isOutAuth, showAllSite: this.showAllSite } }).then((res: any) => {
			this.allSiteCodes = res.allSiteCodes || [];
			return this.openSiteSelectPick(res.siteCodes).then((res: any) => {
				const strArr = res.selected.map((v) => {
					return v.id;
				});
				return strArr;
			});
		})
	}

	openSiteSelectPick(selectArr) {
		// domain
		const protocol = `${location.protocol}//`;
		let hostName = location.hostname;
		hostName.includes('host') && (hostName = 'ips.maintenance.qingger.cn');

		const conds = [
			{
				key: 'status',
				vals: [1],
			}, // 网点状态
			{
				key: 'id',
				op: 'in',
				vals: this.allSiteCodes.length ? this.allSiteCodes : selectArr,
			},
			{ key: 'id', op: 'notIn', vals: this.allSiteCodes.length ? selectArr : [] }
		];

		const params: any = {
			ext_ips__auth_token: this.tokenData.Authorization,
			ext_ips__site: this.siteId,
		};

		const str = JsonToUrlParam(params);
		return client.pick({
			domain: `${protocol + hostName}/scrm/web`,
			path: 'site-select-advn',
			modelDialog: true,
			slide: 'right',
			search: `?baseURL=/nips/scrm&${str}`,
			props: {
				hasPerms: false,
				zIndex: 99999999999,
				readonly: this.readonly,
				config: {
					hasPerms: false,
					subject: 'STORE',
					queryId: null,
					actId: null,
					pure: true,
					multiple: this.multiple,

					conditions: [],
					sicodes: this.selectList || [],
					extProps: {
						excludeCode: this.exArr || [],
					},
					selectBy: ['ranges'],
					rangesConditions: conds,
					filterFields: ['id', 'name', 'type', 'address', 'status', 'orgs'],
				},
			},
			dialogStyle: {
				width: this.readonly?'25vw':'50vw',
				height: '100vh',
				backgroudColor: '#eee',
			},
		});
	}

}
